// src/pages/TargetPage.tsx
import React, {useState} from 'react';
import '../Pages.scss';
import {PageProps} from "../Pages";
import PageButtons from "../../components/PageButtons"; // Import your custom page styles

const MqttPage: React.FC<PageProps> = (props) => {

    const [systemName, setSystemName] = useState<string>(''); // State to store the system name

    const handleSystemNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSystemName(event.target.value); // Update state when input changes
    };

    return (
        <div className="section">
            <h2 className="section-title">System Information</h2>
            <div className="section-description">
                <p>
                    Before we start, let's collect some basic information about your system.
                </p>
            </div>

            <div className="input-title">
                System Name
            </div>
            <div className="input-content">
                <div className="input-description">
                    Enter the name of your system.
                </div>
                <input
                    type="text"
                    id="systemName"
                    value={systemName}
                    onChange={handleSystemNameChange}
                    className="text-input"
                    placeholder="Enter your system name"
                />
            </div>

            <PageButtons next={props.next} prev={props.prev}/>

        </div>
    );

};

export default MqttPage;
